/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyhandright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createUserMachine,
  deleteUserMachine,
  getDynamicColumn,
  getMachineCenterForDropDown,
  getSubModulesByRoleId,
  getUnmappedDocumentType,
  getUnmappedUsersDetails,
  getUserMachineMapping,
  getWorkCenter,
  updateUserMachineCenter,
} from "../../store";

// React-Select component and styling
import Select from "react-select";
import "../../index.css";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForItemsViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 800 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const UserMachine = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getUserMachineMapping,
  getUserMachineReducer,
  createUserMachine,
  updateUserMachineCenter,
  getUnmappedDocumentType,
  getUnmappedDocumentTypeReducer,
  getUnmappedUsersDetails,
  getUnmappedUsersDetailsReducer,
  deleteUserMachine,
  getMachineCenterForDropDown,
  getMachineCenterForDropDownReducer,
  getWorkCenter,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails?.data?.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "21a245df-d7ee-4061-9212-987e2ccee9ea";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let docTypeUserMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "21a245df-d7ee-4061-9212-987e2ccee9ea",
  );

  let createAccess = docTypeUserMapping
    ? docTypeUserMapping.actionId.includes(
        "05b67086-65a5-4db4-9d08-32244a024db8",
      )
    : null;
  let editAccess = docTypeUserMapping
    ? docTypeUserMapping.actionId.includes(
        "37049623-f846-47d9-a27f-23fdced41daf",
      )
    : null;
  let deleteAccess = docTypeUserMapping
    ? docTypeUserMapping.actionId.includes(
        "0d1842c9-0e41-48e8-968c-f18188325093",
      )
    : null;
  let viewAccess = docTypeUserMapping
    ? docTypeUserMapping.actionId.includes(
        "0176c2fc-3eed-4d37-8a44-aef28da1e75b",
      )
    : null;

  useEffect(() => {
    viewAccess &&
      getUserMachineMapping(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  useEffect(() => {
    getMachineCenterForDropDown(jwtToken);
  }, []);

  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getUnmappedDocumentTypeReducer.documentType.data
      ? getUnmappedDocumentTypeReducer.documentType.data
      : [];

    data.map((documentType) => {
      tempDocumentTypeOptions.push({
        label: `${documentType.documentCode} / ${documentType.documentName}`,
        value: documentType.documentId,
      });
    });

    setDocumentTypeOptions(tempDocumentTypeOptions);
  }, [getUnmappedDocumentTypeReducer]);

  const [userDetailsOptions, setDocTypeUserMappingOptions] = useState([]);

  useEffect(() => {
    let tempUsersDetailsOptions = [];
    let data = getUnmappedUsersDetailsReducer.userDetails.data
      ? getUnmappedUsersDetailsReducer.userDetails.data
      : [];
    data.map((UsersDetails) => {
      tempUsersDetailsOptions.push({
        label: `${UsersDetails.userName}`,
        value: UsersDetails.id,
      });
    });

    setDocTypeUserMappingOptions(tempUsersDetailsOptions);
  }, [getUnmappedUsersDetailsReducer]);

  const [skuStatusOptions, setSkuStatusOptions] = useState("");

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getMachineCenterForDropDownReducer.labels.data
      ? getMachineCenterForDropDownReducer.labels.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.machineCode,
        value: activity.machineCenterId,
      });
    });
    setSkuStatusOptions(tempCreatedActivityOptions);
  }, [getMachineCenterForDropDownReducer]);

  const [state, setState] = useState({
    columns: [
      { Header: "userName", accessor: "userName" },
      { Header: "location Code", accessor: "locationCode" },
      { Header: "Machine Code", accessor: "machineCode" },

      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      //   { Header: "User Name", accessor: "userName" },
      {
        Header: "action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [documentTypeCode, setDocumentTypeCode] = useState("");
  const [documentTypeName, setDocumentTypeName] = useState("");

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempDocTypeUser = [];
    let data = getUserMachineReducer?.labels?.data
      ? getUserMachineReducer?.labels?.data
      : [];

    setPaginationObj(getUserMachineReducer?.labels?.pagination);
    setLoading(getUserMachineReducer.loading);
    let filteredData = data.filter(
      (documentType) => documentType.documentTypeId === 1,
    );

    data &&
      data[0]?.cd &&
      data.map((documentType) => {
        const formatDate = new Date(documentType?.cd);
        const documentTypeObj = {
          documentCode: documentType.documentCode,
          locationCode: documentType.locationCode,
          userName: documentType.userName,
          cd: documentType?.cd,
          machineCode: documentType.machineCode,
          createdDate: format(
            addMinutes(formatDate, formatDate?.getTimezoneOffset()),
            "dd/MM/yyyy hh:mm aaa",
          ),
          action: (
            <>
              {editAccess && (
                <EditButton
                  disabled={!editAccess}
                  tooltip="Edit"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => handleOpenUpdateModal(documentType)}
                  style={{ marginRight: "5px" }}
                  // size="small"
                >
                  <Icon>edit_sharp</Icon>
                </EditButton>
              )}
              {deleteAccess && (
                <DeleteButton
                  disabled={!deleteAccess}
                  tooltip="Delete"
                  variant="gradient"
                  style={{ marginRight: "5px" }}
                  // size="small"
                  color="error"
                  iconOnly
                  type="button"
                  onClick={() =>
                    handleOpenDeleteDocTypeUserMappingModal(documentType)
                  }
                >
                  <Icon>delete</Icon>
                </DeleteButton>
              )}
            </>
          ),
        };
        tempDocTypeUser.push(documentTypeObj);
      });

    setState({ ...state, rows: tempDocTypeUser });
  }, [getUserMachineReducer]);

  const [documentTypeSelected, setDocumentTypeSelected] = useState("");
  const handleDocumentTypeChange = (selectedValue) => {
    setDocumentTypeSelected(selectedValue);
  };
  const [MachineCodeSelected, setMachineCodeSelected] = useState("");
  const handleMachineCodeChange = (selectedValue) => {
    setMachineCodeSelected(selectedValue);
  };
  const [userDetailsSelected, setuserDetailsSelected] = useState("");
  const handleUserDetailsChange = (selectedValue) => {
    setuserDetailsSelected(selectedValue);
  };

  const [userSelected, setUserSelected] = useState("");
  const handleUserChange = (selectedValue) => {
    setUserSelected(selectedValue);
  };

  const [isErrorCreateMapping, setIsErrorCreateMapping] = useState(false);
  const [isSuccessCreateMapping, setIsSuccessCreateMapping] = useState(false);

  useEffect(() => {
    if (isErrorCreateMapping) {
      setTimeout(() => {
        setIsErrorCreateMapping(false);
      }, 3000);
    }
  }, [isErrorCreateMapping]);

  useEffect(() => {
    if (isSuccessCreateMapping) {
      setTimeout(() => {
        setIsSuccessCreateMapping(false);
      }, 3000);
    }
  }, [isSuccessCreateMapping]);

  const [openCreateMappingModal, setOpenCreateMappingModal] = useState(false);

  const handleOpenCreateMappingModal = () => {
    setOpenCreateMappingModal(true);
    getUnmappedDocumentType(jwtToken);
    getUnmappedUsersDetails(jwtToken);
  };

  const handleCloseCreateMappingModal = () => {
    setOpenCreateMappingModal(false);
    setDocumentTypeSelected("");
    setUserSelected("");
  };

  const initialValueForCreateMapping = {
    documentType: "",
    userDetails: "",
  };

  const validationSchema = Yup.object({
    documentType: Yup.object().required("Select the documentType!"),
    userDetails: Yup.object().required("Select the user!"),
  });

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");

  const [createButtonName, setCreateButtonName] = useState("Submit");

  const onSubmitForCreateMapping = async (values, { resetForm }) => {
    setCreateButtonName("Please wait...");
    let payload = {
      machineCenterId: documentTypeSelected?.value,
      user_Id: userSelected?.value,
      // userId: userId,
    };
    let res = await createUserMachine(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateMapping(true);

      getUserMachineMapping(pageNo, rowsPerPage, searchObject, jwtToken);
      setDocumentTypeSelected("");
      setUserSelected("");

      setTimeout(() => {
        handleCloseCreateMappingModal();
        setCreateButtonName("Submit");
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res?.data?.data?.msg);
      setIsErrorCreateMapping(true);
      setCreateButtonName("Submit");
    }
  };

  const formikForCreateMapping = useFormik({
    initialValues: initialValueForCreateMapping,
    validationSchema: validationSchema,
    onSubmit: onSubmitForCreateMapping,
  });

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const handleOpenUpdateModal = (data = {}) => {
    setMachineCodeSelected({
      label: `${data.machineCode}`,
      value: data.machineCenterId,
    });
    setuserDetailsSelected({
      label: `${data.userName}`,
      value: data.user_id,
    });
    getUnmappedDocumentType(jwtToken);
    getUnmappedUsersDetails(jwtToken);
    setSingleDataForUpdate(data);
    setOpenUpdateModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateModal = () => {
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [updateErrorMsg, setUpdateErrorMsg] = useState("");
  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    documentType: singleDataForUpdate ? singleDataForUpdate.documentCode : "",
    userDetails: singleDataForUpdate ? singleDataForUpdate.userName : "",
  };

  const validationSchemaForUpdate = Yup.object({
    documentType: Yup.string().required("Select a document type"),
    userDetails: Yup.string().required("Select a user name"),
  });

  const [editButtonName, setEditButtonName] = useState("Submit");
  // const onSubmitForUpdate = async (values) => {
  //   // setUpdateButtonName("Please wait...");
  //   let payload = {
  //     userMachineMapId: singleDataForUpdate.userMachineMapId,
  //     udBy: userId,

  //     machineCenterId: MachineCodeSelected?.value,
  //     user_Id: userDetailsSelected?.value,
  //   };
  //   let res = await updateUserMachineCenter(payload, jwtToken);
  //   if (res.status) {
  //     setIsSuccessForUpdate(true);
  //     getUserMachineMapping(jwtToken);
  //   }
  //   if (!res.status) {
  //     setIsErrorForUpdate(true);
  //     setUpdateErrorMsg(res?.data?.data?.msg);
  //   }
  // };

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      userMachineMapId: singleDataForUpdate.userMachineMapId,
      // udBy: userId,

      machineCenterId: MachineCodeSelected?.value,
      user_Id: userDetailsSelected?.value,
    };
    let res = await updateUserMachineCenter(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getUserMachineMapping(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseUpdateModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setUpdateErrorMsg(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [
    openDeleteDocTypeUserMappingModal,
    setOpenDeleteDocTypeUserMappingModal,
  ] = useState(false);
  const [
    singleDocTypeUserMappingDataForDelete,
    setDocTypeUserMappingDataForDelete,
  ] = useState({});

  const [isErrorDeleteUser, setIsErrorDeleteUser] = useState(false);
  const [isSuccessDeleteUser, setIsSuccessDeleteUser] = useState(false);

  useEffect(() => {
    if (isErrorDeleteUser) {
      setTimeout(() => {
        setIsErrorDeleteUser(false);
      }, 3000);
    }
  }, [isErrorDeleteUser]);

  useEffect(() => {
    if (isSuccessDeleteUser) {
      setTimeout(() => {
        setIsSuccessDeleteUser(false);
      }, 3000);
    }
  }, [isSuccessDeleteUser]);

  const handleOpenDeleteDocTypeUserMappingModal = (userDetails = {}) => {
    setDocTypeUserMappingDataForDelete(userDetails);
    setOpenDeleteDocTypeUserMappingModal(true);
  };
  const handleCloseDeleteDocTypeUserMappingModal = () => {
    setOpenDeleteDocTypeUserMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteDocTypeUserMappingData = async () => {
    setDeleteButtonName("Please wait...");
    let userMachineMapId =
      singleDocTypeUserMappingDataForDelete.userMachineMapId;
    let response = await deleteUserMachine(userMachineMapId, jwtToken);
    if (response.status) {
      getUserMachineMapping(pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccessDeleteUser(true);

      setTimeout(() => {
        handleCloseDeleteDocTypeUserMappingModal();

        setDeleteButtonName("Delete");
      }, 2250);
    }
    if (!response.status) {
      setDeleteErrorMsg(response?.data?.data?.msg);
      setIsErrorDeleteUser(true);

      setDeleteButtonName("Delete");
    }
  };

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getUserMachineMapping(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={2} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                {/* {createAssetAccess && ( */}
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  p={3}
                  // mb={3}
                >
                  {createAccess && (
                    <MDBox color="text" px={2} ml={-2} mb={1}>
                      <CreateButton
                        // disabled={!createAccess}
                        tooltip="Create"
                        color="info"
                        variant="contained"
                        type="button"
                        onClick={handleOpenCreateMappingModal}
                        style={{ marginRight: "5px" }}
                        // size="small"
                        iconOnly
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </MDBox>
                  )}
                </MDBox>

                <MDBox mt={0}>
                  {loadingForDynamicColumn && (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                      options={{ draggable: false }}
                      serverSidePagination={true}
                      paginationObj={paginationObj}
                      pageNoValue={pageNo}
                      rowsPerPageValue={rowsPerPage}
                      pageNoProp={importPageNo}
                      rowsPerPageProp={importRowsPerPage}
                      searchProp={importSearch}
                      loading={loading}
                      hideColumns={hiddenColumsDetails}
                      visibleColumns2={dynamicColumnData?.visibleFields}
                      dynamicColumnData={dynamicColumnData}
                      handleOpenCreateColumnReorderModal={
                        handleOpenCreateColumnReorderModal
                      }
                      subModuleId={subModuleId}
                      userId={userId}
                    />
                  )}
                </MDBox>
                <Modal
                  open={openCreateMappingModal}
                  onClose={handleCloseCreateMappingModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Create
                      </MDTypography>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCreateMappingModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForCreateMapping.handleSubmit}
                      >
                        <MDBox>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              User
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={160}
                              // menuPosition="absolute"
                              // menuPlacement="top"
                              placeholder="Select User..."
                              name="userDetails"
                              value={userSelected}
                              options={userDetailsOptions}
                              onChange={(selectedOption) => {
                                handleUserChange(selectedOption);
                                formikForCreateMapping.setFieldValue(
                                  "userDetails",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForCreateMapping.errors.userDetails && (
                              <TextError
                                msg={formikForCreateMapping.errors.userDetails}
                              />
                            )}
                          </MDBox>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Machine
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={180}
                              menuPosition="absolute"
                              menuPlacement="top"
                              placeholder="Select Document Type..."
                              name="documentType"
                              value={documentTypeSelected}
                              options={skuStatusOptions}
                              onChange={(selectedOption) => {
                                handleDocumentTypeChange(selectedOption);
                                formikForCreateMapping.setFieldValue(
                                  "documentType",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForCreateMapping.errors.documentType && (
                              <TextError
                                msg={formikForCreateMapping.errors.documentType}
                              />
                            )}
                          </MDBox>
                          {/* <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              RG Mapping
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={180}
                              placeholder="Select User..."
                              name="userDetails"
                            //   value={userSelected}
                              menuPlacement="top"
                              menuPosition="absolute"
                            //   options={userDetailsOptions}
                              onChange={(selectedOption) => {
                                handleUserChange(selectedOption);
                                formikForCreateMapping.setFieldValue(
                                  "userDetails",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForCreateMapping.errors.userDetails && (
                              <TextError
                                msg={formikForCreateMapping.errors.userDetails}
                              />
                            )}
                          </MDBox> */}

                          <MDBox mt={2}>
                            <Collapse in={isSuccessCreateMapping}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessCreateMapping(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Created successfully!
                              </Alert>
                            </Collapse>
                            <Collapse in={isErrorCreateMapping}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorCreateMapping(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForCreate}
                              </Alert>
                            </Collapse>
                          </MDBox>

                          <div className="mt-3">
                            <MDButton
                              type="submit"
                              variant="gradient"
                              color="info"
                              fullWidth
                              disabled={
                                !formikForCreateMapping.isValid ||
                                createButtonName === "Please wait..."
                              }
                            >
                              {createButtonName}
                            </MDButton>
                          </div>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openUpdateModal}
                  onClose={handleCloseUpdateModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Update
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseUpdateModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForUpdate.handleSubmit}
                      >
                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            style={{ fontWeight: "500" }}
                          >
                            Machine Code
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="machineCode"
                            options={skuStatusOptions}
                            value={MachineCodeSelected}
                            onChange={(selectedOption) => {
                              handleMachineCodeChange(selectedOption);
                              formikForUpdate.setFieldValue(
                                "machineCode",
                                selectedOption,
                              );
                            }}
                          />
                          {formikForUpdate.errors.machineCode && (
                            <TextError
                              msg={formikForUpdate.errors.machineCode}
                            />
                          )}
                        </MDBox>

                        <MDBox mb={2}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            User
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={180}
                            menuPlacement="top"
                            menuPosition="absolute"
                            placeholder="Select User..."
                            name="userDetails"
                            value={userDetailsSelected}
                            options={userDetailsOptions}
                            onChange={(selectedOption) => {
                              handleUserDetailsChange(selectedOption);
                              formikForUpdate.setFieldValue(
                                "userDetails",
                                selectedOption,
                              );
                            }}
                          />
                          {formikForUpdate.errors.userDetails && (
                            <TextError
                              msg={formikForUpdate.errors.userDetails}
                            />
                          )}
                        </MDBox>

                        <MDBox>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {updateErrorMsg}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openDeleteDocTypeUserMappingModal}
                  onClose={handleCloseDeleteDocTypeUserMappingModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={deleteStyle}>
                    <MDTypography>
                      Are you sure you want to delete this user?
                    </MDTypography>
                    <MDBox mt={2} display="flex">
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleCloseDeleteDocTypeUserMappingModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div style={{ float: "right" }}>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteDocTypeUserMappingData}
                          disabled={deleteButtonName === "Please wait..."}
                        >
                          {deleteButtonName}
                        </MDButton>
                      </div>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessDeleteUser}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessDeleteUser(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Deleted successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorDeleteUser}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorDeleteUser(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {deleteErrorMsg}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openCreateColumnReorderModal}
                  onClose={handleCloseCreateColumnReorderModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForColumnReorder}>
                    <MDTypography>
                      Are you sure you want to submit?
                    </MDTypography>
                    <MDBox mt={2}>
                      <MDButton
                        style={{ width: "10rem", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseCreateColumnReorderModal}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        style={{ width: "10rem", marginLeft: "0.5rem" }}
                        color="success"
                        onClick={handleDynamicColumn}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessColumnReorder}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Data updated successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorColumnReorder}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {isErrorMsgForColumnReorder}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <ToastContainer />
        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getUserMachineReducer: state.getUserMachineReducer,
    getUnmappedDocumentTypeReducer: state.getUnmappedDocumentTypeReducer,
    getUnmappedUsersDetailsReducer: state.getUnmappedUsersDetailsReducer,
    getMachineCenterForDropDownReducer:
      state.getMachineCenterForDropDownReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getUserMachineMapping: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getUserMachineMapping(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    createUserMachine: (payload, jwtToken) =>
      dispatch(createUserMachine(payload, jwtToken)),
    getMachineCenterForDropDown: (jwtToken) =>
      dispatch(getMachineCenterForDropDown(jwtToken)),
    updateUserMachineCenter: (payload, jwtToken) =>
      dispatch(updateUserMachineCenter(payload, jwtToken)),
    deleteUserMachine: (payload, jwtToken) =>
      dispatch(deleteUserMachine(payload, jwtToken)),
    getUnmappedDocumentType: (jwtToken) =>
      dispatch(getUnmappedDocumentType(jwtToken)),
    getUnmappedUsersDetails: (jwtToken) =>
      dispatch(getUnmappedUsersDetails(jwtToken)),
    getWorkCenter: (jwtToken) => dispatch(getWorkCenter(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMachine);
